<div class="print-card-paper" [style.justify-content]="layoutInstructions | verticalCardStackJustification">
  <div
    *ngIf="layoutInstructions | customTopPaperMarginInPx as spacing"
    [style.height.px]="spacing"
    [style.width.%]="100"></div>
  <app-print-card-top-cut-lines
    *ngIf="layoutInstructions | isOnRegularPaper"
    [layoutInstructions]="layoutInstructions"
    [nCardsOnPage]="cardsAsData?.length" />
  <div class="print-card-middle-content">
    <app-print-card-left-cut-lines
      *ngIf="layoutInstructions | isOnRegularPaper"
      [cardsAsData]="cardsAsData"
      [layoutInstructions]="layoutInstructions"
      [nCardsOnPage]="cardsAsData?.length" />
    <app-card-grid [cardsAsData]="cardsAsData" [layoutInstructions]="layoutInstructions" />
    <app-print-card-right-cut-lines
      *ngIf="layoutInstructions | isOnRegularPaper"
      [layoutInstructions]="layoutInstructions"
      [nCardsOnPage]="cardsAsData?.length" />
  </div>
  <app-print-card-bottom-cut-lines
    *ngIf="layoutInstructions | isOnRegularPaper"
    [layoutInstructions]="layoutInstructions"
    [nCardsOnPage]="cardsAsData?.length" />
</div>
